import { Button, Container, Group, Text, Title } from '@mantine/core'
import { useRouter } from 'next/router'
import Layout from '../components/layout/index.js'
import prerenderImportantLocales from '../utils/prerender_locales.js'

const Custom500 = () => {
  const router = useRouter()

  return (
    <Container>
      <Title align="center">500 - Error Interno del Servidor</Title>
      <Text align="center">Lo sentimos, algo salió mal en nuestro servidor.</Text>
      <Group position="center" mt="xl">
        <Button onClick={() => router.push('/')}>Volver al Inicio</Button>
      </Group>
    </Container>
  )
}

Custom500.getLayout = function getLayout(page) {
  return <Layout withAutocomplete>{page}</Layout>
}

export async function getStaticProps({ locale }) {
  prerenderImportantLocales(locale)

  return {
    props: {
      messages: (await import(`../locales/${locale.split('-')[0]}/common.json`))
        .default
    }
  }
}

export default Custom500
